<template>
  <v-dialog v-model="dialog" persistent max-width="290" @keydown.esc="cancel">
    <v-card>
      <v-card-title>
        <div class="headline centerText">{{ title }}</div>
      </v-card-title>
      <v-card-text>
        <div class="subheading centerText grey--text">{{ message }}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" flat @click.native="cancel">{{ this.noBtnLabel }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="agree">{{ this.yesBtnLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    title: null,
    noBtnLabel: 'Disagree',
    yesBtnLabel: 'Agree'
  }),
  methods: {
    open (title, message, noBtnLabel, yesBtnLabel) {
      this.dialog = true
      this.title = title
      this.message = message
      if (!!noBtnLabel) {
        this.noBtnLabel = noBtnLabel
      }
      if (!!yesBtnLabel) {
        this.yesBtnLabel = yesBtnLabel
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      this.resolve(true)
      this.dialog = false
    },
    cancel () {
      this.resolve(false)
      this.dialog = false
    }
  }
}
</script>
